import FontSizeAdjustor from "./FontSizeAdjustor";
import styles from "./FontSizeAdjustor.module.scss";
import { useFontSizeAdjustor } from "../../hooks/fontSizeAdjustorHooks/useFontSizeAdjustor";

const FontSizeAdjustorPopup = ({ position }) => {
  const fontSizeAdjustor = useFontSizeAdjustor();
  return (
    <div className={styles.popupWrapper} style={{ top: position.top }}>
      <button
        type="button"
        aria-label="Close"
        className={styles.closeButton}
        onClick={fontSizeAdjustor.closeModal}
      >
        <i className="tg-icons-Cross"></i>
      </button>
      <FontSizeAdjustor />
    </div>
  );
};

export default FontSizeAdjustorPopup;
